export default {
	NewConfigSend: 'New config send',
	Close: 'Close',
};
